import React from "react";

const BlockWrapper = (props) => {
  return <div className="w-100 p-3 mx-auto">{props.children}</div>;
};

export default BlockWrapper;
